export const isInternalRoute = (an) => "route" in an;
export const isExternalRoute = (an) => "href" in an;
export const isParentRoute = (an) => "children" in an && an.children.length > 0;
//# sourceMappingURL=model.js.map